export default __webpack_public_path__ + "static/media/Raion2.1f4d1205.png";